import React, { Component } from 'react'
import { Form } from 'semantic-ui-react'
import '../styles/InstanceForm.css';

export default class InstanceForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.instance ? props.instance.name : '', 
      url: props.instance ? props.instance.url : '', 
      licenseKey: props.instance ? props.instance.licenseKey : '',
      wellTestDelay: props.instance ? props.instance.wellTestDelay : 1,
      notifications: props.instance ? props.instance.notifications : true,
      percentageAnalysableTests: props.instance ? props.instance.percentageAnalysableTests : 0,
      percentageIncompleteTests: props.instance ? props.instance.percentageIncompleteTests : 0,
      percentageWellsRunning: props.instance ? props.instance.percentageWellsRunning : 0,
      percentageWellsShutdown: props.instance ? props.instance.percentageWellsShutdown : 0,
      percentageWellsCommsFailure: props.instance ? props.instance.percentageWellsCommsFailure : 0,
      percentageWellsCommsFailureManufacturers: props.instance ? props.instance.percentageWellsCommsFailureManufacturers : 0,
      checkPeriodTimeWellsRunning: props.instance ? props.instance.checkPeriodTimeWellsRunning : 0,
      checkPeriodTimeWellsShutdown: props.instance ? props.instance.checkPeriodTimeWellsShutdown : 0,
      checkPeriodTimeWellUpdates: props.instance ? props.instance.checkPeriodTimeWellUpdates : 0,
      checkPeriodTimeInstallationUpdates: props.instance ? props.instance.checkPeriodTimeInstallationUpdates : 0,
      hasESPWells: props.instance ? props.instance.hasESPWells : true,
      hasGLWells: props.instance ? props.instance.hasGLWells : true,
      contactName: props.instance ? props.instance.primaryContact.name : '',
      contactPhone: props.instance ? props.instance.primaryContact.phone : '',
      contactEmail: props.instance ? props.instance.primaryContact.email : '',
      errorName: undefined,
      errorUrl: undefined,
      errorLicenseKey: undefined,
      errorContactName: undefined,
      errorContactPhone: undefined,
      errorContactEmail: undefined,
      errorWellTestDelay: undefined,
      errorPercentageAnalysableTests: undefined,
      errorPercentageIncompleteTests: undefined,
      errorCheckPeriodTimeWellsRunning: undefined,
      errorCheckPeriodTimeWellsShutdown: undefined,
      errorPercentageWellsRunning: undefined,
      errorPercentageWellsShutdowns: undefined,
      errorPercentageWellsCommsFailure: undefined,
      errorPercentageWellsCommsFailureManufacturers: undefined,
      errorCheckPeriodTimeWellUpdates: undefined,
      errorCheckPeriodTimeInstallationUpdates: undefined,
      errorActiveWells: undefined,
      errorCommFailureWells: undefined,
      errorNoDataWells: undefined,
      errorEspWells: undefined,
      errorGasLiftWells: undefined
    };
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  onSubmit = (e) => {
    e.preventDefault();

    if(this.state.name === ''){
      const errorName = "Please enter a client name";
      this.setState(() => ({errorName}));
    } else if (this.state.url === ''){
      const errorUrl = "Please enter a client url";
      this.setState(() => ({errorUrl}));
    } else if (this.state.licenseKey === ''){
      const errorLicenseKey = "Please enter a license key";
      this.setState(() => ({errorLicenseKey}));
    } else if (this.state.wellTestDelay === ''){
      const errorWellTestDelay = "Please enter the expected well test delay period";
      this.setState(() => ({errorWellTestDelay}));
    } else if (this.state.percentageAnalysableTests === ''){
      const errorPercentageAnalysableTests = "Please enter a valid percentage for analysable tests";
      this.setState(() => ({errorPercentageAnalysableTests}));
    } else if (this.state.percentageIncompleteTests === ''){
      const errorPercentageIncompleteTests = "Please enter a valid percentage for incomplete tests";
      this.setState(() => ({errorPercentageIncompleteTests}));
    } else if (this.state.checkPeriodTimeWellsRunning === ''){
      const errorCheckPeriodTimeWellsRunning = "Please enter a valid period of time for wells running";
      this.setState(() => ({errorCheckPeriodTimeWellsRunning}));
    } else if (this.state.checkPeriodTimeWellsShutdown === ''){
      const errorCheckPeriodTimeWellsShutdown = "Please enter a valid period of time for wells shutdown";
      this.setState(() => ({errorCheckPeriodTimeWellsShutdown}));
    } else if (this.state.percentageWellsRunning === ''){
      const errorPercentageWellsRunning = "Please enter a percentage for wells running";
      this.setState(() => ({errorPercentageWellsRunning}));
    } else if (this.state.percentageWellsShutdown === ''){
      const errorPercentageWellsShutdown = "Please enter a percentage for wells shutdown";
      this.setState(() => ({errorPercentageWellsShutdown}));
    } else if (this.state.percentageWellsCommsFailure === ''){
      const errorPercentageWellsCommsFailure = "Please enter a percentage for wells in comms. failure";
      this.setState(() => ({errorPercentageWellsCommsFailure}));
    } else if (this.state.percentageWellsCommsFailureManufacturers === ''){
      const errorPercentageWellsCommsFailureManufacturers = "Please enter a percentage for wells in comms. failure Manufacturers";
      this.setState(() => ({errorPercentageWellsCommsFailureManufacturers}));
    } else if (this.state.checkPeriodTimeWellUpdates === ''){
      const errorCheckPeriodTimeWellUpdates = "Please enter a valid period of time for well updates";
      this.setState(() => ({errorCheckPeriodTimeWellUpdates}));
    } else if (this.state.checkPeriodTimeInstallationUpdates === ''){
      const errorCheckPeriodTimeInstallationUpdates = "Please enter a valid period of time for installation updates";
      this.setState(() => ({errorCheckPeriodTimeInstallationUpdates}));
    } else if (this.state.contactName === ''){
      const errorContactName = "Please enter the name of primary contact";
      this.setState(() => ({errorContactName}));
    } else if (this.state.contactPhone === ''){
      const errorContactPhone = "Please enter a phone number for primary contact";
      this.setState(() => ({errorContactPhone}));
    } else if (this.state.contactEmail === ''){
      const errorContactEmail = "Please enter an email for the contact";
      this.setState(() => ({errorContactEmail}))
    } else {
      const contact = {
        name: this.state.contactName,
        phone: this.state.contactPhone,
        email: this.state.contactEmail
      };
      const instance = {
        name: this.state.name, 
        url: this.state.url, 
        licenseKey: this.state.licenseKey,
        wellTestDelay: parseInt(this.state.wellTestDelay,10),
        notifications: this.state.notifications,
        percentageAnalysableTests: parseFloat(this.state.percentageAnalysableTests),
        percentageIncompleteTests: parseFloat(this.state.percentageIncompleteTests),
        checkPeriodTimeWellsRunning: parseInt(this.state.checkPeriodTimeWellsRunning,10),
        checkPeriodTimeWellsShutdown: parseInt(this.state.checkPeriodTimeWellsShutdown,10),
        percentageWellsRunning: parseFloat(this.state.percentageWellsRunning),
        percentageWellsShutdown: parseFloat(this.state.percentageWellsShutdown),
        percentageWellsCommsFailure: parseFloat(this.state.percentageWellsCommsFailure),
        percentageWellsCommsFailureManufacturers: parseFloat(this.state.percentageWellsCommsFailureManufacturers),
        checkPeriodTimeWellUpdates: parseFloat(this.state.checkPeriodTimeWellUpdates),
        checkPeriodTimeInstallationUpdates: parseFloat(this.state.checkPeriodTimeInstallationUpdates),
        hasESPWells: this.state.hasESPWells,
        hasGLWells: this.state.hasGLWells
      }
      this.props.onSubmit(instance, contact);
    }
  };

  //Grab values from form
  onNameChange = (e) => {
    const name = e.target.value;
    this.setState(() => ({name}));
    this.setState(() => ({errorName: undefined}));
  }

  onUrlChange = (e) => {
    const url = e.target.value;
    this.setState(() => ({url}));
    this.setState(() => ({errorUrl: undefined}));
  }

  onLicenseKeyChange = (e) => {
    const licenseKey = e.target.value;
    this.setState(() => ({licenseKey}));
    this.setState(() => ({errorLicenseKey: undefined}));
  }

  onWellTestDelayChange = (e) => {
    const wellTestDelay = e.target.value;
    this.setState(() => ({wellTestDelay}));
    this.setState(() => ({errorWellTestDelay: undefined}));
  }

  onPercentageAnalysableTests = (e) => {
    const percentageAnalysableTests = e.target.value;
    this.setState(() => ({percentageAnalysableTests}));
    this.setState(() => ({errorPercentageAnalysableTests: undefined}));
  }

  onPercentageIncompleteTests = (e) => {
    const percentageIncompleteTests = e.target.value;
    this.setState(() => ({percentageIncompleteTests}));
    this.setState(() => ({errorPercentageIncompleteTests: undefined}));
  }

  onCheckPeriodTimeWellsRunning = (e) => {
    const checkPeriodTimeWellsRunning = e.target.value;
    this.setState(() => ({checkPeriodTimeWellsRunning}));
    this.setState(() => ({errorCheckPeriodTimeWellsRunning: undefined}));
  }

  onCheckPeriodTimeWellsShutdown = (e) => {
    const checkPeriodTimeWellsShutdown = e.target.value;
    this.setState(() => ({checkPeriodTimeWellsShutdown}));
    this.setState(() => ({errorCheckPeriodTimeWellsShutdown: undefined}));
  }

  onPercentageWellsRunning = (e) => {
    const percentageWellsRunning = e.target.value;
    this.setState(() => ({percentageWellsRunning}));
    this.setState(() => ({errorPercentageWellsRunning: undefined}));
  }

  onPercentageWellsShutdown = (e) => {
    const percentageWellsShutdown = e.target.value;
    this.setState(() => ({percentageWellsShutdown}));
    this.setState(() => ({errorPercentageWellsShutdown: undefined}));
  }

  onPercentageWellsCommsFailure = (e) => {
    const percentageWellsCommsFailure = e.target.value;
    this.setState(() => ({percentageWellsCommsFailure}));
    this.setState(() => ({errorPercentageWellsCommsFailure: undefined}));
  }

  
  onPercentageWellsCommsFailureManufacturers = (e) => {
    const percentageWellsCommsFailureManufacturers = e.target.value;
    this.setState(() => ({percentageWellsCommsFailureManufacturers}));
    this.setState(() => ({errorPercentageWellsCommsFailureManufacturers: undefined}));
  }

  onCheckPeriodTimeWellUpdates = (e) => {
    const checkPeriodTimeWellUpdates = e.target.value;
    this.setState(() => ({checkPeriodTimeWellUpdates}));
    this.setState(() => ({errorCheckPeriodTimeWellUpdates: undefined}));
  }

  onCheckPeriodTimeInstallationUpdates = (e) => {
    const checkPeriodTimeInstallationUpdates = e.target.value;
    this.setState(() => ({checkPeriodTimeInstallationUpdates}));
    this.setState(() => ({errorCheckPeriodTimeInstallationUpdates: undefined}));
  }

  onHasESPWells = (e, { checked }) => {
    const hasESPWells = checked;
    this.setState(() => ({hasESPWells}));
  }

  onHasGLWells = (e, { checked }) => {
    const hasGLWells = checked;
    this.setState(() => ({hasGLWells}));
  }

  onContactNameChange = (e) => {
    const contactName = e.target.value;
    this.setState(() => ({contactName}));
    this.setState(() => ({errorContactName: undefined}));
  }

  onContactPhoneChange = (e) => {
    const contactPhone = e.target.value;
    this.setState(() => ({contactPhone}));
    this.setState(() => ({errorContactPhone: undefined}));
  }

  onContactEmailChange = (e) => {
    const contactEmail = e.target.value;
    this.setState(() => ({contactEmail}));
    this.setState(() => ({errorContactEmail: undefined}));
  }

  render() {
    return (
      <div>
        {this.state.error && <p>{this.state.error}</p>}
        <Form onSubmit={this.onSubmit}>
          <Form.Group widths='equal'>
            <Form.Input
              label='Client Name'
              placeholder='Name'
              name='name'
              type='text'
              error= {this.state.errorName}
              value={this.state.name}
              onChange={this.onNameChange}
            />
            <Form.Input
              label='URL of Client'
              placeholder='sm.pumpchecker.com'
              name='url'
              type='text'
              error= {this.state.errorUrl}
              value={this.state.url}
              onChange={this.onUrlChange}
            />
            <Form.Input
              label='License Key'
              placeholder='JFJGJD84N3'
              name='licenseKey'
              type='text'
              error= {this.state.errorLicenseKey}
              value={this.state.licenseKey}
              onChange={this.onLicenseKeyChange}
            />
          </Form.Group>
          
          <Form.Group widths='equal'>
            <Form.Input
              label='Name of Primary Contact'
              placeholder='e.g. Katy Bell'
              name='contactName'
              type='text'
              error= {this.state.errorContactName}
              value={this.state.contactName}
              onChange={this.onContactNameChange}
            />
            <Form.Input
              label='Phone Number'
              placeholder='0141 876 8163'
              name='contactPhone'
              type='text'
              error= {this.state.errorContactPhone}
              value={this.state.contactPhone}
              onChange={this.onContactPhoneChange}
            />
            <Form.Input
              label='Email'
              placeholder='user@pumpchecker.com'
              name='contactEmail'
              type='text'
              error= {this.state.errorContactEmail}
              value={this.state.contactEmail}
              onChange={this.onContactEmailChange}
            />
          </Form.Group>
          <h2>Tag Settings</h2>
          <Form.Group widths='equal'>
            
            <Form.Input
              label='Well Test Delay Expected (Days)'
              placeholder='1'
              name='wellTestDelay'
              type='number'
              error= {this.state.errorWellTestDelay}
              value={this.state.wellTestDelay}
              onChange={this.onWellTestDelayChange}
            />
  
            <Form.Input
              label='Percentage of Analysable Tests (%)'
              placeholder='5'
              name='percentageAnalysableTests'
              type='number'
              error= {this.state.errorPercentageAnalysableTests}
              value={this.state.percentageAnalysableTests}
              onChange={this.onPercentageAnalysableTests}
            />
            <Form.Input
              label='Percentage of Incomplete Tests (%)'
              placeholder='5'
              name='percentageIncompleteTests'
              type='number'
              error= {this.state.errorPercentageIncompleteTests}
              value={this.state.percentageIncompleteTests}
              onChange={this.onPercentageIncompleteTests}
            />
          </Form.Group>
          <Form.Group widths='equal'>
            
            <Form.Input
              label='Check Period of Time for Wells Running (hours)'
              placeholder='3'
              name='checkPeriodTimeWellsRunning'
              type='number'
              error= {this.state.errorCheckPeriodTimeWellsRunning}
              value={this.state.checkPeriodTimeWellsRunning}
              onChange={this.onCheckPeriodTimeWellsRunning}
            />
            <Form.Input
              label='Percentage of Wells Running (%)'
              placeholder='5'
              name='percentageWellsRunning'
              type='number'
              error= {this.state.errorPercentageWellsRunning}
              value={this.state.percentageWellsRunning}
              onChange={this.onPercentageWellsRunning}
            />
          </Form.Group>
          <Form.Group widths='equal'>
            
            <Form.Input
              label='Check Period of Time for Wells Shutdown (hours)'
              placeholder='3'
              name='checkPeriodTimeWellsShutdown'
              type='number'
              error= {this.state.errorCheckPeriodTimeWellsShutdown}
              value={this.state.checkPeriodTimeWellsShutdown}
              onChange={this.onCheckPeriodTimeWellsShutdown}
            />
            <Form.Input
              label='Percentage of Wells Shutdown (%)'
              placeholder='5'
              name='percentageWellsShutdown'
              type='number'
              error= {this.state.errorPercentageWellsShutdown}
              value={this.state.percentageWellsShutdown}
              onChange={this.onPercentageWellsShutdown}
            />
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Input
              label='Percentage of Wells in Comms. Failure (%)'
              placeholder='10'
              name='percentageWellsCommsFailure'
              type='number'
              error= {this.state.errorPercentageWellsCommsFailure}
              value={this.state.percentageWellsCommsFailure}
              onChange={this.onPercentageWellsCommsFailure}
            />
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Input
              label='Percentage of Wells in Comms. Failure Manufacturers(%)'
              placeholder='75'
              name='percentageWellsCommsFailureManufacturers'
              type='number'
              error= {this.state.errorPercentageWellsCommsFailureManufacturers}
              value={this.state.percentageWellsCommsFailureManufacturers}
              onChange={this.onPercentageWellsCommsFailureManufacturers}
            />
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Input
              label='Check Period of Time for Well Updates (hours)'
              placeholder='1'
              name='checkPeriodTimeWellUpdates'
              type='number'
              error= {this.state.errorCheckPeriodTimeWellUpdates}
              value={this.state.checkPeriodTimeWellUpdates}
              onChange={this.onCheckPeriodTimeWellUpdates}
            />
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Input
              label='Check Period of Time for Installation Updates (hours)'
              placeholder='1'
              name='checkPeriodTimeInstallationUpdates'
              type='number'
              error= {this.state.errorCheckPeriodTimeInstallationUpdates}
              value={this.state.checkPeriodTimeInstallationUpdates}
              onChange={this.onCheckPeriodTimeInstallationUpdates}
            />
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Checkbox
              label='Does it has ESP Wells?'
              name='hasESPWells'
              checked={this.state.hasESPWells}
              onChange={this.onHasESPWells}
            />
            <Form.Checkbox
              label='Does it has GL Wells?'
              name='hasGLWells'
              checked={this.state.hasGLWells}
              onChange={this.onHasGLWells}
            />
          </Form.Group>
          <Form.Group>
            <Form.Button content='Save' />
            <div className="ui button discard" onClick={() => {this.props.history.push("/Instances")} }>Discard</div>
          </Form.Group>
        </Form>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/InstanceForm.js